var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.544 68L0 34 40.544 0l-.01 11.333-27.273 22.723 27.395 22.642L40.544 68zM72 67.907L31.456 34 72 .093v67.814z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzIgNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGlkPSJSZXN0YXJ0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQwLjU0MzggNjhMMCAzNEw0MC41NDM4IDBMNDAuNTM0OCAxMS4zMzMzTDEzLjI2MTUgMzQuMDU1N0w0MC42NTU1IDU2LjY5NzhMNDAuNTQzOCA2OFpNNzIgNjcuOTA2NkwzMS40NTYyIDM0TDcyIDAuMDkzMzUzN1Y2Ny45MDY2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgRestart as ReactComponent };